import { createStore } from "vuex";
import storage from "@/utils/storage";

export default createStore({
  // 数据存放的位置
  state: {
    user_evaluation: "",
    userinfo: storage.getItem("user_default_account") || {}, // 用户信息
  },
  mutations: {
    data(state, data) {
      state.user_evaluation = data;
    },
    // 设置用户信息
    setUsetInfo(state, data) {
      console.log("data", data);
      state.userinfo = data;
      storage.setItem("user_default_account", data);
    },
  },
  actions: {
    dataone(context, data) {
      context.commit("data", data);
    },
  },
  modules: {},
});
